import getFetchResponse, { ApiResponse } from '../../get-fetch-response'

export type CountryCallingCodePayload = ApiResponse & {
  countryCallingCodes: string[][]
}

// https://petstore.swagger.io/?url=https://staging-api.thriveglobal.com/v1/swagger.json#/sms/get_country_calling_codes
export const getCountryCallingCodes = async () => {
  const res = await getFetchResponse<CountryCallingCodePayload>(
    { method: 'GET', path: '/v2/sms/get_country_calling_codes' },
    true
  )

  return res
}
